import { TEMA_ICONS } from '../data/icons.js';

export function temaPref() {
  let v = 'escuro';
  try { v = localStorage.getItem('torre:tema') || 'escuro'; } catch (e) {}
  return v === 'claro' ? 'claro' : 'escuro';
}

export function aplicarTema(pref) {
  const claro = pref === 'claro';
  document.documentElement.setAttribute('data-theme', claro ? 'light' : 'dark');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', claro ? '#f3f4f7' : '#0c0d10');
  document.querySelectorAll('[data-theme-btn]').forEach((b) => {
    b.innerHTML = TEMA_ICONS[pref] || TEMA_ICONS.escuro;
  });
  document.querySelectorAll('#theme-menu [data-tema]').forEach((b) => {
    b.setAttribute('aria-checked', b.dataset.tema === pref ? 'true' : 'false');
  });
}

export function bindTheme({ onEscape, onInfo } = {}) {
  const themeMenu = document.getElementById('theme-menu');
  function fecharMenuTema() { themeMenu.hidden = true; }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-theme-btn]');
    if (btn) {
      if (!themeMenu.hidden) { fecharMenuTema(); return; }
      themeMenu.hidden = false;
      const r = btn.getBoundingClientRect();
      const w = themeMenu.offsetWidth;
      themeMenu.style.top = (r.bottom + 8) + 'px';
      themeMenu.style.left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - w / 2)) + 'px';
      themeMenu.querySelector('[aria-checked="true"]')?.focus();
      return;
    }
    const item = e.target.closest('#theme-menu [data-tema]');
    if (item) {
      try { localStorage.setItem('torre:tema', item.dataset.tema); } catch (err) {}
      aplicarTema(item.dataset.tema);
      fecharMenuTema();
      return;
    }
    if (!e.target.closest('#theme-menu')) fecharMenuTema();
    const info = e.target.closest('[data-info]');
    if (info) onInfo?.(info.dataset.info);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (!themeMenu.hidden) fecharMenuTema();
      else onEscape?.();
    }
  });
  window.addEventListener('scroll', fecharMenuTema, { passive: true });
  aplicarTema(temaPref());
}
